import { gql, useMutation } from '@apollo/client'

import {
  UseVoteComment_CommentFragment,
  VoteDocumentCommentMutation,
  VoteDocumentCommentMutationVariables,
} from './__generated__/use-vote-comment.graphql'

const VoteCommentMutation = gql`
  mutation voteDocumentComment($input: VoteDocumentCommentInput!) {
    voteDocumentComment(input: $input) {
      totalVotes
      currentVote
      oldVote
    }
  }
`
interface UseVoteCommentProps {
  comment: UseVoteComment_CommentFragment
}

export const useVoteComment = ({ comment }: UseVoteCommentProps) => {
  const [vote, { loading }] = useMutation<
    VoteDocumentCommentMutation,
    VoteDocumentCommentMutationVariables
  >(VoteCommentMutation, {
    update(cache, { data: mutate }) {
      cache.modify({
        id: cache.identify(comment),
        fields: {
          upVotes() {
            return mutate?.voteDocumentComment?.totalVotes
          },
          viewerUpVoted() {
            return mutate?.voteDocumentComment?.currentVote === 'POSITIVO'
          },
          viewerDownVoted() {
            return mutate?.voteDocumentComment?.currentVote === 'NEGATIVO'
          },
        },
      })
    },
  })

  return {
    vote,
    loading,
  }
}

useVoteComment.fragments = {
  comment: gql`
    fragment UseVoteComment_comment on DocumentComment {
      id
    }
  `,
}
